export default class Subnav {
	constructor($module) {
		this.$module = $module;
		this.mobileTitle = document.querySelector(".bc-account-title");
		this.mobileToggle = this.$module.querySelector(".bc-sub-nav__mobile-toggle");
		this.mobileMediaQuery = window.matchMedia("(max-width: 1024px)");

		this.bindSubNavTriggers();
		this.bindMobileTitle();
		this.bindViewportReset();
	}

	bindSubNavTriggers() {
		const triggers = this.$module.querySelectorAll(".sub-nav-trigger");

		for (let i = 0; i < triggers.length; i++) {
			triggers[i].addEventListener("click", (event) => {
				const item = event.currentTarget.closest(".bc-sub-nav__item");
				if (!item) {
					return;
				}

				item.classList.toggle("bc-sub-nav__item--open");
				event.currentTarget.setAttribute(
					"aria-expanded",
					item.classList.contains("bc-sub-nav__item--open") ? "true" : "false"
				);
			});
		}
	}

	bindMobileTitle() {
		if (this.mobileToggle) {
			this.mobileToggle.addEventListener("click", () => {
				this.toggleMobileNav();
			});
		}

		if (this.mobileTitle && !this.mobileToggle) {
			this.mobileTitle.addEventListener("click", () => {
				this.toggleMobileNav();
				this.mobileTitle.toggleAttribute("open");
			});
		}
	}

	toggleMobileNav() {
		if (!this.mobileMediaQuery.matches) {
			return;
		}

		this.$module.classList.toggle("bc-sub-nav--open");

		if (this.mobileToggle) {
			this.mobileToggle.setAttribute(
				"aria-expanded",
				this.$module.classList.contains("bc-sub-nav--open") ? "true" : "false"
			);
		}
	}

	bindViewportReset() {
		this.mobileMediaQuery.addEventListener("change", (event) => {
			if (!event.matches) {
				this.$module.classList.remove("bc-sub-nav--open");

				if (this.mobileToggle) {
					this.mobileToggle.setAttribute("aria-expanded", "false");
				}
			}
		});
	}
}
